import React from 'react';

const CampaignProgressStatus = ({ status, progress, getStatusColor }) => {
  const isRunning = progress?.status === 'running';

  if (isRunning) {
    const percent = progress.percent ?? 0;
    return (
      <div className="min-w-[150px]">
        <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
          <span className="font-medium text-blue-700">Running</span>
          <span>{percent}%</span>
        </div>
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 transition-all duration-300 ease-out"
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className="text-xs text-gray-500 mt-1">
          {progress.processed || 0}/{progress.total || 0}
          {(progress.sent > 0 || progress.failed > 0) && (
            <span>
              {' '}· {progress.sent || 0} sent
              {progress.failed > 0 ? `, ${progress.failed} failed` : ''}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <span className={`px-2 py-1 text-xs rounded-full capitalize ${getStatusColor(status)}`}>
      {status || 'draft'}
    </span>
  );
};

export default CampaignProgressStatus;
